import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Navbar from "../../nav_bar/Navbar";
import Footer from "../../footer/Footer";
import { fetchCategoryById } from "./officialSentenceService";
import "./OfficialSentenceListPage.css";

const levelColor = (l) => ({ EASY: "#4caf50", MEDIUM: "#ff9800", HARD: "#e91e63" }[l?.toUpperCase()] || "#999");

const OfficialSentenceCategoryPage = () => {
  const { categoryId } = useParams();
  const navigate = useNavigate();
  const [cat, setCat] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const load = async () => {
      console.log("[OfficialSentenceCategoryPage] Loading category id:", categoryId);
      setLoading(true);
      const res = await fetchCategoryById(categoryId);
      if (res.status === 200 && res.data?.status) {
        console.log("[OfficialSentenceCategoryPage] Category loaded:", res.data.data?.title, "sentences:", res.data.data?.sentences?.length || 0);
        setCat(res.data.data);
      } else { console.error("[OfficialSentenceCategoryPage] Load failed:", res.status, res.message); }
      setLoading(false);
    };
    load();
  }, [categoryId]);

  if (loading) return (<><Navbar /><div className="os-cat-page"><p className="os-loading">Loading...</p></div><Footer /></>);
  if (!cat) return (<><Navbar /><div className="os-cat-page"><p className="os-loading">Category not found.</p><button className="os-back" onClick={() => navigate("/study/official-sentences")}>← Back</button></div><Footer /></>);

  return (
    <>
      <Navbar />
      <div className="os-cat-page">
        <button className="os-back" onClick={() => navigate("/study/official-sentences")}>← Back to Official Sentences</button>
        <div className="os-cat-hero">
          <span className="os-cat-icon">{cat.icon || "📂"}</span>
          <h1 className="os-cat-title">{cat.title}</h1>
          {cat.description && <p className="os-cat-desc">{cat.description}</p>}
        </div>
        {cat.youtubeVideoUrl && (
          <div className="os-video-card">
            {cat.videoTitle && <h3 className="os-video-title">🎬 {cat.videoTitle}</h3>}
            {cat.videoDescription && <p className="os-video-desc">{cat.videoDescription}</p>}
            <div className="os-video-wrapper">
              <iframe src={cat.youtubeVideoUrl.replace("watch?v=", "embed/").replace("youtu.be/", "youtube.com/embed/")} title={cat.videoTitle || cat.title} allowFullScreen frameBorder="0" />
            </div>
          </div>
        )}
        {(!cat.sentences || cat.sentences.length === 0) ? (<p className="os-loading">No sentences in this category yet.</p>) : (
          <div className="os-sentence-list">
            {cat.sentences.map((s) => (
              <div key={s.id} className="os-sentence-item" onClick={() => navigate(`/study/official-sentences/${s.id}`)}>
                <div className="os-sentence-info">
                  <h3 className="os-sentence-title">{s.title}</h3>
                  {s.description && <p className="os-sentence-desc">{s.description}</p>}
                </div>
                <span className="os-sentence-level" style={{ background: levelColor(s.level) }}>{s.levelDisplayName || s.level}</span>
                <span className="os-sentence-arrow">→</span>
              </div>
            ))}
          </div>
        )}
      </div>
      <Footer />
    </>
  );
};

export default OfficialSentenceCategoryPage;
